<template>
  <a-modal
    :title="title"
    :visible="visible"
    @cancel="handleCancel"
    @ok="handleCancel"
    @close="handleCancel"
    width="1200px">
    <div class="order-info">
      <table>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card :bordered="false" title="收款账户"
              :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
              :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">预付余额：</td>
                  <td class="data">{{ this.form1.forceBalance }}</td>
                  <td class="first">实时余额：</td>
                  <td class="data">{{ this.form1.reBalance }}</td>
                  <td class="first">当前可用余额：</td>
                  <td class="data">{{ this.form1.curBalance }}</td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card :bordered="false" title="分账商户账户"
              :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
              :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">预付余额：</td>
                  <td class="data">{{ this.form3.forceBalance }}</td>
                  <td class="first">实时余额：</td>
                  <td class="data">{{ this.form3.reBalance }}</td>
                  <td class="first">当前可用余额：</td>
                  <td class="data">{{ this.form3.curBalance }}</td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>
        <tr>
<!--          <td style="vertical-align: top;background-color:#fbfbfb;">-->
<!--            <a-card :bordered="false" title="分账接收方账户"-->
<!--              :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"-->
<!--              :bodyStyle="{'background-color':'#fbfbfb'}">-->
<!--              <table class="info-table">-->
<!--                <tr>-->
<!--                  <td class="first">预付余额：</td>-->
<!--                  <td class="data">{{ this.form4.forceBalance }}</td>-->
<!--                  <td class="first">实时余额：</td>-->
<!--                  <td class="data">{{ this.form4.reBalance }}</td>-->
<!--                  <td class="first">当前可用余额：</td>-->
<!--                  <td class="data">{{ this.form4.curBalance }}</td>-->
<!--                </tr>-->
<!--              </table>-->
<!--            </a-card>-->
<!--          </td>-->
        </tr>
      </table>
    </div>
    <div style="height: 25px"></div>
    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="handleCancel">{{$t('取消')}}</a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>
import {balance} from '@/api/shop/extraApplyLakala'

export default {
  name: 'LakalaBalance',
  props: {},
  data() {
    return {
      title: undefined,
      loading: false,
      visible: false,
      form1: { forceBalance: 0, curBalance: 0, reBalance: 0 },
      form3: { forceBalance: 0, curBalance: 0, reBalance: 0 },
      form4: { forceBalance: 0, curBalance: 0, reBalance: 0 },
    }
  },
  methods: {
    handleCancel() {
      this.visible = false
      this.reset()
    },
    reset() {
      this.form = { orderId: undefined, addressId: undefined, isAdmin: true }
    },
    handleDetail(shopId) {
      balance({ "shopId": shopId, payType: "01" }).then(res => {
        this.form1 = res.data
        this.visible = true;
      }).finally(() => { this.loading = false });
      balance({ "shopId": shopId, payType: "03" }).then(res => {
        this.form3 = res.data
        this.visible = true;
      }).finally(() => { this.loading = false });
      // balance({ "shopId": shopId, payType: "04" }).then(res => {
      //   this.form4 = res.data
      //   this.visible = true;
      // }).finally(() => { this.loading = false });
    },
  }
}
</script>
<style scoped>
.order-info {
  border: 1px solid #e8e8e8;
  margin-top: 40px;
}
.info-table tr { height: 50px; }
.info-table td {
  display: table-cell;
  vertical-align: top;
  font-size: 16px;
}
.info-table .first { width: 100px; }
.info-table .data { width: 300px; }
</style>
